import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppLoaderService } from './services/app-loader.service';

export function init_app(appLoaderService: AppLoaderService) {
  return () => appLoaderService.load();
}

@NgModule({
  imports: [HttpClientModule],
  providers: [
    AppLoaderService,
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppLoaderService], multi: true },
  ],
})
export class AppLoaderModule {}
